import React, { useState } from 'react'
import { GetAppointmentByIdOutput } from '../../../../Adaptor/TUBSIS/controllers/Appointments/models/getAppointmentModels'
import { Button, Col, FloatingLabel, Form, FormControl, Modal, Row } from 'react-bootstrap'
import { updateAppointment } from '../../../../Adaptor/TUBSIS/controllers/Appointments/Appointments'

type Props = {appointment: GetAppointmentByIdOutput}

const AppointmentUpdate : React.FC<Props> = ({ appointment }) => {
  
    const [showModal, setShowModal] = useState(false);

    const [appointmentStartDate, setAppointmentStartDate] = useState<Date | null>(null);
    const [isFirstAppointment, setIsFirstAppointment] = useState<boolean | null>(null);
    const [appointmentEndDate, setAppointmentEndDate] = useState<Date | null>(null);

    const clearForm = () => {
        setAppointmentStartDate(null)
        setAppointmentEndDate(null)
    }

    const openModal = () => {
        clearForm()
        setAppointmentStartDate(appointment.appointmentStartDate)
        setAppointmentEndDate(appointment.appointmentEndDate)
        setIsFirstAppointment(appointment.isFirstAppointment)
        setShowModal(true);
    };

    const closeModal = () => {
        clearForm()
        setShowModal(false);
        //window.location.reload();
    };

    const parseAppointmentDateStringToDate = (dateString: string): Date | null => {
        const dateRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/;
        const match = dateString.match(dateRegex);
        if (!match) return null;
    
        const year = parseInt(match[1]);
        const month = parseInt(match[2]) - 1;
        const day = parseInt(match[3]);
        const hour = parseInt(match[4]);
        const minute = parseInt(match[5]);
    
        const parsedDate = new Date(year, month, day, hour, minute);

        // Oluşturulan tarihin geçerli olup olmadığını kontrol et
        const currentDate = new Date();
        if (parsedDate <= currentDate) return null;

        return parsedDate;
    };

    const [isValidStartDate, setIsValidStartDate] = useState<boolean>(true);
    const [isValidEndDate, setIsValidEndDate] = useState<boolean>(true);

    const handleItemChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type } = e.target;
        if (name === 'appointmentStartDate') {
            const parsedDate = parseAppointmentDateStringToDate(value)
            setAppointmentStartDate(parsedDate);
            setIsValidStartDate(parsedDate !== null);
        } else if (name === 'appointmentEndDate') {
            const parsedDate = parseAppointmentDateStringToDate(value)
            setAppointmentEndDate(parsedDate);
            setIsValidEndDate(parsedDate !== null);
        } else if (type === 'checkbox' && name === 'isFirstAppointment') {
            //console.log(!isFirstAppointment)
            setIsFirstAppointment(!isFirstAppointment);      
        }
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement | HTMLButtonElement>) => {
        e.preventDefault();

        if (appointment.expertId === null || appointment.expertId <= 0 || isNaN(appointment.expertId)) {
            // Eğer uzman seçilmemişse, hata mesajı göster
            alert("Uzman bulunamadı.");
            return;
        }

        if (appointment.patientId === null || appointment.patientId <= 0 || isNaN(appointment.patientId)) {
            // Eğer danışan seçilmemişse, hata mesajı göster
            alert("Danışan bulunamadı.");
            return;
        }
        
        if (!isValidStartDate || !isValidEndDate || appointmentStartDate === null || appointmentEndDate === null ) {
            return;
        }
    
        let parsedAppointmentStartDate = new Date(appointmentStartDate)
        let parsedAppointmentEndDate = new Date(appointmentEndDate)

        parsedAppointmentStartDate.setHours(parsedAppointmentStartDate.getHours() + 3)
        parsedAppointmentEndDate.setHours(parsedAppointmentEndDate.getHours() + 3)

        const requestModel = {
            AppointmentId: appointment.appointmentId,
            ExpertId: appointment.expertId,
            PatientId: appointment.patientId,
            AppointmentStartDate: new Date(parsedAppointmentStartDate),
            AppointmentEndDate: new Date(parsedAppointmentEndDate),
            IsFirstAppointment: isFirstAppointment??true,
            PatientWasHere: false
        };

        const response = await updateAppointment(requestModel);

        if (response.success){
            alert(response.message);
        } else {
            alert(response.message);
            return;
        }

        closeModal(); // Modalı kapat
    };

    return (
      <div>
        <button 
            type="button" 
            title="Randevuyu Düzenle"
            className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1" 
            onClick={() => openModal()}>
            <i className="ki-duotone ki-pencil fs-2"><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span></i>                                    
        </button>
        <Modal show={showModal} onHide={closeModal}>
            <Modal.Header closeButton>
                <Modal.Title>Randevu Düzenle</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    {/* <FloatingLabel className='mb-3' controlId="expertId" key={-1} label="Uzman">
                        <Form.Select name="expertId">
                            <option key={appointment.expertId} value={appointment.expertId}>
                                {appointment.expertFullName}
                            </option>
                        </Form.Select>
                    </FloatingLabel> */}

                    <FloatingLabel className='mb-3' controlId="patientId" label="Danışan">
                        <Form.Select name="patientId">
                            <option key={appointment.patientId} value={appointment.patientId}>
                                {appointment.patientFullName}
                            </option>
                        </Form.Select>
                    </FloatingLabel>

                    <Row className="mb-3">
                        <Form.Group as={Col}>
                            <FloatingLabel controlId="appointmentStartDate" label="Randevu Başlangıç Tarihi">
                                <FormControl 
                                    type="datetime-local" 
                                    name="appointmentStartDate"
                                    defaultValue={appointment.appointmentStartDate.toString()}
                                    isInvalid={!isValidStartDate}
                                    onChange={handleItemChange} />
                                <Form.Control.Feedback type="invalid">
                                    Geçerli bir tarih ve saat girin.
                                </Form.Control.Feedback>
                            </FloatingLabel>
                        </Form.Group>

                        <Form.Group as={Col}>
                            <FloatingLabel controlId="appointmentEndDate" label="Randevu Bitiş Tarihi">
                                <FormControl 
                                    type="datetime-local" 
                                    name="appointmentEndDate" 
                                    defaultValue={appointment.appointmentEndDate.toString()}
                                    isInvalid={!isValidEndDate}
                                    onChange={handleItemChange} />
                                <Form.Control.Feedback type="invalid">
                                    Geçerli bir tarih ve saat girin.
                                </Form.Control.Feedback>
                            </FloatingLabel>
                        </Form.Group>
                    </Row>

                    <Form.Check
                        type="checkbox"
                        id="isFirstAppointment"
                        label="İlk Randevu Mu?"
                        name="isFirstAppointment"
                        checked={isFirstAppointment ? true : false}
                        onChange={handleItemChange}
                    />
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={closeModal}>
                    Kapat
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                    Kaydet
                </Button>
            </Modal.Footer>
        </Modal>
      </div>
    )
}

export default (AppointmentUpdate)